import { Instance, Objekt, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { resources } from '../resources';
import { AdminCountryService } from '../services/adminCountryService';
import { LanguageService } from '../services/languageService';
import { AdminController } from './adminController';

export class AdminCountriesIndexController extends AdminController {
    private table: Table;

    constructor(
        instances: Instance,
        private adminCountryService: AdminCountryService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton(
            '.btn-admin-index',
            this.dom,
            () => {
                this.state.goBack('admin.index');
            },
            '',
            true,
            [],
        );
    }

    protected override _initTable(): void {
        if (!this.table) {
            this.table = new Table(
                this.dom,
                'table',
                this.adminCountryService.getTableOptions(),
            );

            this.table.setActions([
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (country) => {
                        this.adminCountryService
                            .editDialog(country, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ]);

            this.table.eventAction = (params) => {
                params.set('query', this.query);
                params.set('fields', this.adminCountryService.getTableFields());
                this.adminCountryService.getAll(params).then((response) => {
                    const count = response.get<number>('count');
                    this.table.setCount(count);
                    const countries = response.get<Objekt[]>('countries');
                    this.table.setData(countries);
                });
            };

            this.table.render();
        } else {
            this.table.refresh();
        }
    }
}

export const adminCountriesIndexController = app.controller(
    resources.adminCountriesIndexController,
    [
        resources.instances,
        resources.adminCountryService,
        resources.languageService,
    ],
    AdminCountriesIndexController,
);
